import Vue from "vue";
import Vuex from "vuex";
import { applyTheme } from "./theme";
import betslip from "./store/betslip";
Vue.use(Vuex);

const DEFAULT_PREFERENCES = {
  theme: "light",
  odds_format: "fraction",
  leagues: [],
};

// Mirror of the saved preferences so theme and odds apply before GET /user returns.
function storedPreferences() {
  try {
    const saved = JSON.parse(localStorage.getItem("NGPreferences"));
    return saved ? { ...DEFAULT_PREFERENCES, ...saved } : DEFAULT_PREFERENCES;
  } catch (e) {
    return DEFAULT_PREFERENCES;
  }
}

const initialPreferences = storedPreferences();
applyTheme(initialPreferences.theme);

const store = new Vuex.Store({
  modules: { betslip },
  state: {
    accessTokens: {},
    subscriptionType: false,
    customerID: false,
    userID: false,
    isAmericas: false,
    isBetPromoAllowed: false,
    stripeProductCode: false,
    preferences: initialPreferences,
    account: false,
    leagues: [],
  },
  mutations: {
    isAmericas(state, payload) {
      state.isAmericas = payload;
    },
    isBetPromoAllowed(state, payload) {
      state.isBetPromoAllowed = payload;
    },
    storeAccessTokens(state, payload) {
      state.accessTokens = payload;
      if (payload.access_token) {
        localStorage.setItem("NGAccessTokens", JSON.stringify(payload));
        // console.log("We just updated access tokens to", payload);
      } else {
        localStorage.removeItem("NGAccessTokens");
      }
    },
    storeSubscriptionType(state, payload) {
      state.subscriptionType = payload;
    },
    storeCustomerID(state, payload) {
      state.customerID = payload;
    },
    storeUserID(state, payload) {
      state.userID = payload;
      if (payload) {
        localStorage.setItem("NGUserID", payload);
      } else {
        localStorage.removeItem("NGUserID");
      }
    },
    updateStripeCode(state, payload) {
      state.stripeProductCode = payload;
    },
    storePreferences(state, payload) {
      state.preferences = payload
        ? { ...DEFAULT_PREFERENCES, ...payload }
        : DEFAULT_PREFERENCES;
      if (payload) {
        localStorage.setItem("NGPreferences", JSON.stringify(state.preferences));
      } else {
        localStorage.removeItem("NGPreferences");
      }
      applyTheme(state.preferences.theme);
    },
    storeAccount(state, payload) {
      state.account = payload;
    },
    storeLeagues(state, payload) {
      state.leagues = payload || [];
    },
  },
  getters: {
    isAmericas(state) {
      return state.isAmericas;
    },
    isBetPromoAllowed(state) {
      return state.isBetPromoAllowed;
    },
    accessTokens(state) {
      return state.accessTokens;
    },
    subscriptionType(state) {
      return state.subscriptionType;
    },
    customerID(state) {
      return state.customerID;
    },
    userID(state) {
      return state.userID;
    },
    stripeProductCode(state) {
      return state.stripeProductCode;
    },
    preferences(state) {
      return state.preferences;
    },
    account(state) {
      return state.account;
    },
    leagues(state) {
      return state.leagues;
    },
    // Names of the user's preferred leagues, as they appear on match cards (match.competition).
    preferredLeagueNames(state) {
      const byId = {};
      state.leagues.forEach((league) => {
        byId[league.id] = league.name;
      });
      return state.preferences.leagues
        .map((id) => byId[id])
        .filter((name) => name);
    },
  },
});

export default store;
